






















































import { Component, Vue } from 'vue-property-decorator';
import { vxm } from './../store.vuex';

@Component({
  name: 'Notification',
  components: {
  }
})
export default class Notification extends Vue {
  get isLoggedIn() {
    console.log('url', this.thisURL);
    return vxm.users.isLoggedIn;
  }
  get thisURL() {
    return window.location.href.split('/')[window.location.href.split('/').length - 1];
  }

}
